import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { DataService } from './services/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = 'Angular';
  env = environment;
  langs: string[] = [];

  constructor( 
    private translate: TranslateService,
    private route: ActivatedRoute,
    private dataService: DataService
  ){
    this.translate.setDefaultLang('es');
    this.translate.addLangs(['en', 'es', 'cat']);
    if (localStorage.getItem('language')){
      this.translate.use(localStorage.getItem('language'));
    }
    else{
      this.translate.use('es');
    }
    // this.translate.addLangs(['en', 'it']);
  }

  ngOnInit(){
    // this.dataService.getLang().subscribe(res => {
    //   this.translate.use(res.toString());
    // });
  }
  
}


